import { Spin, Tabs } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import UserProfile from './Settings/Profile';

import { ROLES } from '../../constants';

import API from './Settings/API';
import './Settings.scss';
import DeliveryArea from './Settings/DeliveryArea';
import Integrations from './Settings/Integrations';
import TrackTrace from './Settings/TrackTrace/TrackTrace';
import Labels from './Settings/Labels';
import { DeliveryMethodSettings } from './Settings/DeliveryMethodSettings';
import usePageView from '../../hooks/usePageView';
import Carriers from './Settings/Carriers';
import { ShippingRules } from './Settings/ShippingRules';
import { NPSSettings } from './Settings/NPS';
import { CarrierRules } from './Settings/CarrierRules';

const SettingsPage = ({ activeTab }) => {
  const isFetching = useSelector((state) => state.auth.isFetching);
  const user = useSelector((state) => state.auth.user);
  const role = useSelector((state) => state.auth.user.role);

  // Emit page view event
  usePageView(window.location.href);

  const items = [
    {
      key: 'user-profile',
      label: 'User Profile',
      children: <UserProfile user={user} />,
    },
  ];

  if ([ROLES.ADMIN, ROLES.COMPANY_OWNER].includes(role)) {
    items.push({
      key: 'integrations',
      label: 'Integrations',
      children: <Integrations />,
    });
    items.push({
      key: 'track-trace',
      label: 'Track & Trace',
      children: <TrackTrace />,
    });
    items.push({
      key: 'delivery-methods',
      label: 'Delivery Methods',
      children: <DeliveryMethodSettings />,
    });
  }
  if ([ROLES.ADMIN, ROLES.COMPANY_OWNER].includes(role)) {
    items.push({
      key: 'labels',
      label: 'Labels',
      children: <Labels />,
    });
  }

  if ([ROLES.ADMIN].includes(role)) {
    items.push({
      key: 'carriers',
      label: 'Carriers',
      children: <Carriers />,
    });
    items.push({
      key: 'delivery-areas',
      label: 'Delivery Areas',
      children: <DeliveryArea />,
    });
    items.push({
      key: 'shipping-rules',
      label: 'Shipping rules',
      children: <ShippingRules />,
    });
    items.push({
      key: 'nps',
      label: 'NPS',
      children: <NPSSettings />,
    });
    items.push({
      key: 'carrier-rules',
      label: 'Carrier rules',
      children: <CarrierRules />,
    });

    // items.push({
    //   key: '8',
    //   label: 'Pricing',
    //   children: <PricingSettings />,
    // });

    // items.push({
    //   key: '4',
    //   label: 'Routing',
    //   children: <Routing />,
    // });
  }

  // Add API Page
  items.push({
    key: 'api',
    label: 'API',
    children: <API user={user} />,
  });

  // // Add feature flags for sparqle admin
  // if (role === ROLES.ADMIN && /@sparqle.com$/.test(user?.email)) {
  //   items.push({
  //     key: 'sparqle-labs',
  //     label: 'Sparqle Labs',
  //     children: <FeatureFlags />,
  //   });
  // }
  return (
    <Spin spinning={isFetching}>
      <div className="SettingsPage Content">
        <div className="ContentHeader">
          <div className="HeaderTitle">Settings</div>
        </div>
        <div className="ContentMain">
          <Tabs defaultActiveKey={activeTab} items={items} destroyInactiveTabPane />
        </div>
      </div>
    </Spin>
  );
};

export default SettingsPage;
